import React from 'react';
import ScrollView from 'devextreme-react/scroll-view';
import './single-card.scss';
import logo from '../../images/logo1.png';
import marketingLogo from '../../images/1.png';

export default function SingleCard({ title, description, children }) {
  const showImage = true;
  return (
    <ScrollView height={'100%'} width={'100%'} className={'with-footer single-card'}>


      <div id="banner" role="banner" style={{ background: 'transparent', fontSize: '15px' }}>
        <div id="heading" style={{ fontSize: '15px' }}>
          <div className="site-title" style={{ fontSize: '15px' }}>
            <a className="logo custom-logo" href="/home" title="Go to Customer Connect" style={{ fontSize: '15px' }}>
              <img alt="Customer Connect" src={logo} style={{ fontSize: '15px' }} />
            </a>
            {/* <div className="pull-right hidden-lg" style={{ fontSize: '13px' }}>
              <a href=" mailto:info@britam.com" className="tapBtn" style={{ fontSize: '13px' }}>
                <i className="icon icon-envelope" style={{ fontSize: '13px' }}></i>
              </a>
              <a href="#" className="tapBtn dropdown-toggle" data-toggle="dropdown" id="callBtn" style={{ fontSize: '13px' }}>
                <i className="icon icon-phone" style={{ fontSize: '13px' }}></i>
              </a>
              <ul className="dropdown-menu callNow" style={{ fontSize: '15px' }}>
                <li style={{ fontSize: '15px' }}>
                  <span style={{ fontSize: '15px' }}>Call Us : </span>
                  <a href="tel: 0705100100" style={{ fontSize: '15px' }}>
                    <i className="icon icon-phone" style={{ fontSize: '15px' }}></i> 0705100100
                  </a>
                </li>
              </ul>
            </div> */}
            <div className="topheadLeft pull-right visible-lg" style={{ fontSize: '13px' }}>
              <div className="col-1" style={{ fontSize: '13px' }}>
                <ul style={{ fontSize: '13px' }}>
                  <li style={{ fontSize: '13px' }}>
                    <img className="icon" alt="icon" src="https://customerconnect.britam.com/o/customer-login-theme/images/call.png" style={{ fontSize: '13px' }} />
                    +233302218500
                  </li>
                </ul>
              </div>
            </div>
          </div>
          
        </div>
      </div>

      {/* <img src={marketingLogo} alt="Marketing"  /> */}
      <div style={{ width: '80%', margin: 'auto' }}>
        <section className="row">
          <div className="col-md-8">
            <img src={marketingLogo} alt="Marketing" style={{ maxWidth: '100%', height: 'auto' }} />
            {/* <div className="image-caption">
              OUR COMMITMENT<br />
              To Be With You In<br />
              Every Step of The Way
            </div> */}
          </div>
          <div className="col-md-4" style={{ marginLeft: '0%' }}>
            <div className={'dx-card content'}>
              {/* <div className={'header'}>
                <div className={'title'}>{title}</div>
                <div className={'description'}>{description}</div>
              </div> */}
              {children}
            </div>
          </div>
        </section>
      </div>
    </ScrollView>
  );
}
